import React from "react";
import Agent from "./agent.jsx";

export const addNewService = async (newService, shopId, serviceGroupId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  const params = {
    ShopId: shopId,
    Name: newService.name,
    Description: newService.description, // e.g. "Monday" or number (0-6)
    Price: newService.price, // e.g. "Monday" or number (0-6)
    ServiceGroupId: serviceGroupId, // "17:00:00"
    IsRepeatable: newService.isRepeatable,
    OrderNumber: newService.displayOrderNumber,
  };
  return await requests.post(`/service`, params, token, shopId);
};

export const editServices = async (editService, shopId) => {
  const token = localStorage.getItem("authToken");

  const params = {
    ShopId: shopId,
    Id: editService.id,
    Name: editService.name,
    Description: editService.description,
    Price: editService.price,
    IsRepeatable: editService.isRepeatable,
    ServiceGroupId: editService.selectedServiceGroup.id,
    OrderNumber: editService.displayOrderNumber,
  };
  const { requests } = Agent();
  return await requests.put(`/service/`, params, token, shopId);
};
export const deleteService = async (shopId, serviceId) => {
  try {
    const token = localStorage.getItem("authToken");

    const { requests } = Agent();
    return await requests.del(
      `/service?id=${serviceId}&shopId=${shopId}`,
      token,
      shopId,
    );
  } catch (error) {
    console.error(
      "Error updating service:",
      error.response?.data || error.message,
    );
    throw error;
  }
};
